// import {FontAwesomeIcon} from '@fortawesome/react-native-fontawesome';
// import {faArrowDownToSquare, faFileXmark} from '@fortawesome/pro-light-svg-icons';
import {
  faBookmark as proLightFaBookmark,
  faChevronDown as proLightFaChevronDown,
  faChevronLeft as proLightFaChevronLeft,
  faChevronRight as proLightFaChevronRight,
  faChevronUp as proLightFaChevronUp,
  faGear as proLightFaGear,
  faLocationDot as proLightFaLocationDot,
  faMapLocationDot as proLightFaMapLocationDot,
  faPen as proLightFaPen,
  faPlus as proLightFaPlus,
  faShare as proLightFaShare,
  faTrashCan as proLightFaTrashCan,
  faXmark as proLightFaXmark
} from '@fortawesome/pro-light-svg-icons';
import {
  faBars as proRegularBars,
  faBell,
  faChevronLeft as proRegularChevronLeft,
  faHouseBlank,
  faMapLocationDot as proRegularFaMapLocationDot,
  faMapPin,
  faPanorama,
  faRouteHighway,
  faShare as proRegularFaShare
} from '@fortawesome/pro-regular-svg-icons';
import {
  faArrowDownToSquare,
  faAxe,
  faBars,
  faBinoculars,
  faBookmark,
  faCampground,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faCircleInfo,
  faCirclePlay,
  faCircleQuestion,
  faCloudSunRain,
  faCrosshairs,
  faDroneFront,
  faFileXmark,
  faFish,
  faFishingRod,
  faGear,
  faHandPointUp,
  faHouse,
  faLocationArrow,
  faLocationDot,
  faMap,
  faMapLocationDot,
  faPersonBiking,
  faPersonHiking,
  faPersonWalking,
  faPickaxe,
  faRectangleXmark,
  faRestroom,
  faShareNodes,
  faSignHanging,
  faSignsPost,
  faSquareParking,
  faStarSharp,
  faTablePicnic,
  faTrees,
  faTriangleExclamation,
  faWifi,
} from '@fortawesome/pro-solid-svg-icons';
// import { faHouseBlank } from '@fortawesome/pro-regular-svg-icons';
import {
  faPersonWalking as thinFaPersonWalking,
  faLocationDot as thinFaLocationDot,
  faBell as thinFaBell
} from '@fortawesome/pro-thin-svg-icons';

export const getIcon = (iconName: string | null) => {
  switch (iconName) {
    case 'fa-light fa-bookmark':
      return proLightFaBookmark;
    case 'fa-light fa-chevron-down':
      return proLightFaChevronDown;
    case 'fa-light fa-chevron-left':
      return proLightFaChevronLeft;
    case 'fa-light fa-chevron-right':
      return proLightFaChevronRight;
    case 'fa-light fa-chevron-up':
      return proLightFaChevronUp;
    case 'fa-light fa-gear':
      return proLightFaGear;
    case 'fa-light fa-location-dot':
      return proLightFaLocationDot;
    case 'fa-light fa-map-location-dot':
      return proLightFaMapLocationDot;
    case 'fa-light fa-pen':
      return proLightFaPen;
    case 'fa-light fa-plus':
      return proLightFaPlus;
    case 'fa-light fa-share':
      return proLightFaShare;
    case 'fa-light fa-trash-can':
      return proLightFaTrashCan;
    case 'fa-light fa-xmark':
      return proLightFaXmark;
    case 'fa-regular fa-bars':
      return proRegularBars;
    case 'fa-regular fa-bell':
      return faBell;
    case 'fa-regular fa-chevron-left':
      return proRegularChevronLeft;
    case 'fa-regular fa-location-crosshairs':
      return faCrosshairs;
    case 'fa-regular fa-house-blank':
      return faHouseBlank;
    case 'fa-regular fa-map':
      return faMap;
    case 'fa-regular fa-map-location-dot':
      return proRegularFaMapLocationDot;
    case 'fa-regular fa-map-pin':
      return faMapPin;
    case 'fa-regular fa-panorama':
      return faPanorama;
    case 'fa-regular fa-route-highway':
      return faRouteHighway;
    case 'fa-regular fa-share':
      return proRegularFaShare;
    case 'fa-solid fa-arrow-down-to-square':
      return faArrowDownToSquare;
    case 'fa-solid fa-axe':
      return faAxe;
    case 'fa-solid fa-bars':
      return faBars;
    case 'fa-solid fa-bookmark':
      return faBookmark;
    case 'fa-solid fa-binoculars':
      return faBinoculars;
    case 'fa-solid fa-campground':
      return faCampground;
    case 'fa-solid fa-chevron-left':
      return faChevronLeft;
    case 'fa-solid fa-chevron-right':
      return faChevronRight;
    case 'fa-solid fa-circle':
      return faCircle;
    case 'fa-solid fa-circle-info':
      return faCircleInfo;
    case 'fa-solid fa-circle-question':
      return faCircleQuestion;
    case 'fa-solid fa-circle-play':
      return faCirclePlay;
    case 'fa-solid fa-cloud-sun-rain':
      return faCloudSunRain;
    case 'fa-solid fa-drone-front':
      return faDroneFront;
    case 'fa-solid fa-file-xmark':
      return faFileXmark;
    case 'fa-solid fa-fish':
      return faFish;
    case 'fa-solid fa-fishing-rod':
      return faFishingRod;
    case 'fa-solid fa-gear':
      return faGear;
    case 'fa-solid fa-house':
      return faHouse;
    case 'fa-solid fa-location-arrow':
      return faLocationArrow;
    case 'fa-solid fa-location-dot':
      return faLocationDot;
    case 'fa-solid fa-map':
      return faMap;
    case 'fa-solid fa-map-location-dot':
      return faMapLocationDot;
    case 'fa-solid fa-person-biking':
      return faPersonBiking;
    case 'fa-solid fa-person-hiking':
      return faPersonHiking;
    case 'fa-solid fa-person-walking':
      return faPersonWalking;
    case 'fa-solid fa-pickaxe':
      return faPickaxe;
    case 'fa-solid fa-rectangle-xmark':
      return faRectangleXmark;
    case 'fa-solid fa-restroom':
      return faRestroom;
    case 'fa-solid fa-share-nodes':
      return faShareNodes;
    case 'fa-solid fa-square-parking':
      return faSquareParking;
    case 'fa-solid fa-sign-hanging':
      return faSignHanging;
    case 'fa-solid fa-signs-post':
      return faSignsPost;
    case 'fa-solid fa-star-sharp':
      return faStarSharp;
    case 'fa-solid fa-table-picnic':
      return faTablePicnic;
    case 'fa-solid fa-trees':
      return faTrees;
    case 'fa-solid fa-triangle-exclamation':
      return faTriangleExclamation;
    case 'fa-solid fa-wifi':
      return faWifi;
    case 'fa-thin fa-bell':
      return thinFaBell;
    case 'fa-thin fa-location-dot':
      return thinFaLocationDot;
    case 'fa-thin fa-person-walking':
      return thinFaPersonWalking;
    default:
      return faHandPointUp;
  }
};

export default getIcon;
